export class DecodeHTMLEntities
{
    decodeHTMLEntities(encodedString:string) 
    {
        let translateRe = /&(nbsp|amp|quot|lt|gt);/g;
        let translate = {
            "nbsp":" ",
            "amp" : "&",
            "quot": "\"",
            "lt"  : "<",
            "gt"  : ">"
        };
        return encodedString.replace(translateRe, function(match, entity) {
            return translate[entity];
        }).replace(/&#(\d+);/gi, function(match, numStr) {
            var num = parseInt(numStr, 10);
            return String.fromCharCode(num);
        });
    }
}    


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/decodehtmlentities.tsx